import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import RealNameRecords from "@/views/user/components/RealNameRecords.vue";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-user",
  components: {
    RealNameRecords: RealNameRecords
  },
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        status: 0,
        // 0:全部，1:待认证，2:认证中, 3:已认证，4:欠费
        phone: this.$route.query.phone,
        name: "",
        remark: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      authNotCount: 0,
      // 待认证
      authProcessCount: 0,
      // 认证中
      authSuccessCount: 0,
      // 已认证
      oweCount: 0,
      // 欠费人数

      currentRow: {},
      // 当前行
      remarkDialogVisible: false,
      // 备注弹窗
      amount: "",
      // 充值金额
      topUpDialogVisible: false // 充值弹窗
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    goApartmentAudit: function goApartmentAudit(row) {
      window.open("#/brand/apartment/audit?phone=".concat(row.phone, "&brandStatus=all"));
    },
    // 退款
    brandAccountRefund: function brandAccountRefund(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this2.$api.isAutoRefund({
                userId: row.id
              });
            case 1:
              res = _context3.v;
              _this2.$confirm(res.data.autoRefund == 1 ? "退款" : res.data.tips, "操作确认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var res;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.brandAccountRefund({
                        userId: row.id
                      });
                    case 1:
                      res = _context2.v;
                      _this2.getData();
                      _this2.$message.success("操作成功");

                      // 操作上报
                      _this2.$operationLog.push({
                        code: "refund",
                        userId: row.id,
                        operationType: "brand_refund",
                        detailBatchNo: res.data.id
                      });
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 通过认证
    setUserTypeStatus: function setUserTypeStatus(row, status) {
      var _this3 = this;
      this.$confirm("品牌认证", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$api.setUserTypeStatus({
                user_id: row.id,
                user_type_status: status
              });
            case 1:
              _this3.getData();
              _this3.$message.success("操作成功");
              if (!(status == 3)) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return _this3.$api.setRiskDeviceAndCategory({
                'user_id': row.id
              });
            case 2:
              // 操作上报
              _this3.$operationLog.push({
                code: status == 3 ? "pass" : "reject",
                userId: row.id,
                operationType: "user"
              });
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      })));
    },
    // 品牌充值
    brandTopUp: function brandTopUp() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$api.brandTopUp({
                userId: _this4.currentRow.id,
                amount: _this4.amount
              });
            case 1:
              res = _context5.v;
              _this4.$message.success("充值成功");
              _this4.getData();
              _this4.amount = "";
              _this4.topUpDialogVisible = false;

              // 操作上报
              _this4.$operationLog.push({
                code: "recharge",
                userId: _this4.currentRow.id,
                operationType: "brand_top_up",
                detailBatchNo: res.data.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              _this5.tableLoading = true;
              _context6.n = 1;
              return _this5.$api.getBrandUserList(_this5.searchForm);
            case 1:
              res = _context6.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.authNotCount = res.data.authNotCount;
              _this5.authProcessCount = res.data.authProcessCount;
              _this5.authSuccessCount = res.data.authSuccessCount;
              _this5.oweCount = res.data.oweCount;
              _this5.tableLoading = false;
              _this5.getUserListByIds(_this5.tableData, "id");
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    }
  }
};